import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ButtonHoverAnimation from "./button/ButtonHoverAnimation";
const Wallet = () => {
  const [isFaqOpen, setIsFaqOpen] = useState(false);

  const toggleFAQ = () => {
    setIsFaqOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // Add or remove class to the body tag based on dropdown state
    if (isFaqOpen) {
      document.body.classList.add("faq-open");
    } else {
      document.body.classList.remove("faq-open");
    }
  }, [isFaqOpen]);

  return (
    <>
      <ButtonHoverAnimation />
      <main data-barba="container" data-barba-namespace="secondary">
        <div className="min-svh-100 d-flex align-items-center justify-content-center px-3 px-sm-4 px-md-5 opacity-load">
          <div className="container">
            <div className="spacer"></div>
            <div className="my-4">
              <h1 className="text-center">Brain Management</h1>
              <div className="d-flex flex-column flex-md-row flex-wrap align-items-center justify-content-center mt-4 gap-4  mt-lg-5 gap-lg-5">
                <div>
                  {/* TODO: Change to Stake Brains */}
                  <Link className="btn" to="/acquire-brain">
                    {/* <Link className="btn" to="/burning"> */}
                    <span className="d-flex align-items-center">
                      <em>
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="12.6599" cy="12" r="12" fill="#75FBFD" />
                          <path
                            d="M12.6599 8.75815L15.2533 11.9999L12.6599 15.2416"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </em>
                      Acquire Brains
                    </span>
                  </Link>
                </div>
                <div>
                  <Link className="btn" to="/my-inventory">
                    <span className="d-flex align-items-center">
                      <em>
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="12.6599" cy="12" r="12" fill="#75FBFD" />
                          <path
                            d="M12.6599 8.75815L15.2533 11.9999L12.6599 15.2416"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </em>
                      My Inventory
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="pt-1">
              <Link
                className="underline-on-hover-2 d-flex align-items-center mx-auto mt-4 justify-content-center"
                to="https://docs.basedlabs.net/faqs/1HI2EMcqBRs5rMjbyo5Q/"
              >
                <span>Learn More</span>
                <em className="ps-2">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ transform: "rotate(180deg)" }}
                  >
                    <circle cx="12.4526" cy="12.3848" r="12" fill="#75FBFD" />
                    <path
                      d="M13.7493 15.6265L11.1559 12.3848L13.7493 9.14306"
                      stroke="black"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </em>
              </Link>
            </div>

            <div className="spacer"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Wallet;
